var _defs, _rect, _g, _g2, _g3, _g4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPasswordSuccessBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1600,
    height: 1200,
    viewBox: "0 0 1600 1200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "successGradient",
    x1: 0,
    y1: 0,
    x2: 1600,
    y2: 1200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0f172a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#1f2937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#334155"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "successGlow",
    cx: 0.5,
    cy: 0.5,
    r: 0.65
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#facc15",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#facc15",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "confetti",
    cx: 0.5,
    cy: 0.5,
    r: 0.5
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f97316"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f97316",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1600,
    height: 1200,
    fill: "url(#successGradient)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 260,
    r: 220,
    fill: "url(#successGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1260,
    cy: 360,
    r: 180,
    fill: "url(#successGlow)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 960,
    r: 260,
    fill: "url(#successGlow)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M300 840c0-33 27-60 60-60h280c33 0 60 27 60 60v60c0 33-27 60-60 60H360c-33 0-60-27-60-60v-60z",
    fill: "url(#confetti)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M980 880c0-22 18-40 40-40h220c22 0 40 18 40 40v60c0 22-18 40-40 40H1020c-22 0-40-18-40-40v-60z",
    fill: "url(#confetti)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#f8fafc",
    opacity: 0.08
  }, /*#__PURE__*/React.createElement("rect", {
    x: 260,
    y: 220,
    width: 360,
    height: 220,
    rx: 32
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1040,
    y: 200,
    width: 320,
    height: 200,
    rx: 28
  }), /*#__PURE__*/React.createElement("rect", {
    x: 600,
    y: 500,
    width: 420,
    height: 240,
    rx: 40
  }), /*#__PURE__*/React.createElement("rect", {
    x: 200,
    y: 540,
    width: 280,
    height: 260,
    rx: 48
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1090,
    y: 540,
    width: 280,
    height: 260,
    rx: 48
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    stroke: "#f8fafc",
    strokeOpacity: 0.12,
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 520,
    cy: 400,
    r: 120
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1100,
    cy: 420,
    r: 110
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 800,
    cy: 640,
    r: 180
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasswordSuccessBg);
export default __webpack_public_path__ + "static/media/password-success-bg.4b135344b567bbe67c93b69e1bc41351.svg";
export { ForwardRef as ReactComponent };